import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Modal,
  Box,
  Typography,
  TextField,
  Stack
} from "@mui/material";

interface User {
  email: string;
  endDate: string;
}

interface UserTableProps {
  responseMessage: string|null;
  users: User[];
  onDelete: (email: string) => void;
  onEditEndDate: (email: string, currentEndDate: string) => void;
  onUpdatePassword: (email: string, password: string) => void;
}

const UserTable: React.FC<UserTableProps> = ({
  responseMessage,
  users,
  onDelete,
  onEditEndDate,
  onUpdatePassword
}) => {   


  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (responseMessage) {
      setMessage(responseMessage);  // Обновляем состояние message, когда responseMessage изменяется
    }
  }, [responseMessage]);

  const handleOpen = (user: User) => {
    setSelectedUser(user);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setNewPassword("");
    setConfirmPassword("");
    setSelectedUser(null);
    setMessage("");
  };

  // const handleSubmit = async (email: string, password: string) => {
  //   if (password !== confirmPassword) {
  //     setMessage("Passwords do not match");
  //     return;
  //   }
  
  // const resultMessage = await updatePassword(email, password);
  //   setMessage(resultMessage); // Установите сообщение для модального окна
  // };

  return (
  <>
  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Email</TableCell>
          <TableCell>End Date</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.email}>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.endDate}</TableCell>
            <TableCell>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => onEditEndDate(user.email, user.endDate)}
                sx={{ marginRight: 1 }}
              >
                Edit End Date
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => onDelete(user.email)}
                sx={{ marginRight: 1 }}
              >
                Delete
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => handleOpen(user)}
                
              >
                Change password
              </Button>
            </TableCell>
            </TableRow>
          
        ))}
      </TableBody>
    </Table>
  </TableContainer>
  <Modal open={open} onClose={handleClose}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6" mb={2}>
      Change Password for {selectedUser?.email}
    </Typography>
    <Stack spacing={2}>
    {message && (
        <Typography color={message.includes("successfully") ? "green" : "red"}>
          {message}
        </Typography>
      )}
      <TextField
        label="New Password"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        fullWidth
      />
      <TextField
        label="Confirm Password"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        fullWidth
      />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          if (newPassword !== confirmPassword) {
            setMessage("Passwords do not match");
            return;
          }
          
          if (!selectedUser?.email) {
            alert("No user selected or email is missing.");
            return;
          }
          
          onUpdatePassword(selectedUser.email, newPassword);
        }}
      >
        Save
      </Button>
      <Button variant="outlined" color="secondary" onClick={handleClose}>
        Cancel
      </Button>
    </Stack>
  </Box>
  </Modal>
  </>
  );
}

export default UserTable;
